import { SText } from "@/components/atoms";
import SHeading from "@/components/atoms/SHeading";
import MachineCard from "@/components/molecules/MachineCard";
import {
  IMG_HIGH_ANGLE,
  IMG_WHITE_STANDARD_ANGLE,
  IMG_MACHINR_DOUBLE,
  IMG_AI_PHOTOBOOTH,
  IMG_TWO_VIEW_PHOTOBOOTH,
  IMG_MACHINR_DULUXE,
  IMG_MACHINR_SNAP4U,
  IMG_MACHINR_SNAP_MOBILE,
  IMG_SELFBOOTH_SMART,
} from "@/constants";
import React from "react";
import { useTranslation } from "react-i18next";

const MachineOptions = () => {
  const { t } = useTranslation();

  const cardData = [
    {
      scrImg: IMG_WHITE_STANDARD_ANGLE,
      widthImg: 250,
      tag: t("home.machine_options.card1.tag"),
      stextHeading: t("home.machine_options.card1.heading"),
      describeText: t("home.machine_options.card1.description"),
    },
    {
      scrImg: IMG_HIGH_ANGLE,
      widthImg: 250,
      tag: t("home.machine_options.card2.tag"),
      stextHeading: t("home.machine_options.card2.heading"),
      describeText: t("home.machine_options.card2.description"),
    },
    {
      scrImg: IMG_MACHINR_DOUBLE,
      widthImg: 250,
      tag: t("home.machine_options.card3.tag"),
      stextHeading: t("home.machine_options.card3.heading"),
      describeText: t("home.machine_options.card3.description"),
    },
    {
      scrImg: IMG_AI_PHOTOBOOTH,
      widthImg: 250,
      tag: t("home.machine_options.card4.tag"),
      stextHeading: t("home.machine_options.card4.heading"),
      describeText: t("home.machine_options.card4.description"),
    },
    {
      scrImg: IMG_TWO_VIEW_PHOTOBOOTH,
      widthImg: 250,
      tag: t("home.machine_options.card5.tag"),
      stextHeading: t("home.machine_options.card5.heading"),
      describeText: t("home.machine_options.card5.description"),
    },
    {
      scrImg: IMG_MACHINR_DULUXE,
      widthImg: 250,
      tag: t("home.machine_options.card6.tag"),
      stextHeading: t("home.machine_options.card6.heading"),
      describeText: t("home.machine_options.card6.description"),
    },
    {
      scrImg: IMG_MACHINR_SNAP4U,
      widthImg: 250,
      tag: t("home.machine_options.card7.tag"),
      stextHeading: t("home.machine_options.card7.heading"),
      describeText: t("home.machine_options.card7.description"),
    },
    {
      scrImg: IMG_MACHINR_SNAP_MOBILE,
      widthImg: 250,
      tag: t("home.machine_options.card8.tag"),
      stextHeading: t("home.machine_options.card8.heading"),
      describeText: t("home.machine_options.card8.description"),
    },
    {
      scrImg: IMG_SELFBOOTH_SMART,
      widthImg: 250,
      tag: t("home.machine_options.card9.tag"),
      stextHeading: t("home.machine_options.card9.heading"),
      describeText: t("home.machine_options.card9.description"),
    },
  ];

  const formatTag = (tag: string): React.ReactNode => {
  const domain = "Snap4u.vn";
  const url = "https://snap4u.vn";

  if (!tag.includes(domain)) return tag;

  const parts = tag.split(domain);

  return (
      <span>
        {parts[0]}
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          {domain}
        </a>
        {parts[1]}
      </span>
    );
  };

  return (
    <div id="machines" className="max-w-7xl mx-auto mt-16 mb-4 px-4">
      <SHeading
        text={t("home.machine_options.title")}
        tAlign="center"
        className="mt-6 mb-3 font-bold md:text-3xl text-xl"
      />
      <SText
        className="text-center font-light mb-5 mx-auto max-w-[600px]"
        text={t("home.machine_options.description")}
      />

      <div className="container mx-auto mt-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16">
          {cardData.map((card, index) => (
            <MachineCard
              key={`card-machine-${index}`}
              scrImg={card.scrImg}
              tag={formatTag(card.tag)}
              stextHeading={card.stextHeading}
              describeText={card.describeText}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MachineOptions;
